import { render, staticRenderFns } from "./FoldersItem.vue?vue&type=template&id=693e42eb&scoped=true"
import script from "./FoldersItem.vue?vue&type=script&lang=js"
export * from "./FoldersItem.vue?vue&type=script&lang=js"
import style0 from "./FoldersItem.vue?vue&type=style&index=0&id=693e42eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693e42eb",
  null
  
)

export default component.exports